<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="page-main">
      <div class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="backToVps"></el-button>
        <span class="se-panel-title z-padding-left-5-precent ver-sub">云服务器管理</span>
      </div>
      <div class="server-header" :class="{'server-windows':vpsInfo.OsType_1 === 'Windows','server-centos':vpsInfo.OsType_1 === 'CentOS','server-ubuntu':vpsInfo.OsType_1 === 'Ubuntu','server-close':basic.loading === 'ok' || basic.state.indexOf('关机') === 0}" v-loading="listLoading">
        <table class="server-header-table">
          <tr>
            <td>
              <span class="z-font-size-14 z-color-333">{{vpsInfo.vps_name}}</span>
            </td>
            <td>&nbsp;&nbsp;&nbsp;</td>
            <td>
              <span v-if="basic.loading != 'ok'" class="z-color-green-state state-icon" :class="{'server-state-run':basic.state.indexOf('运行') === 0,'server-state-stop':basic.state.indexOf('关机') === 0}">{{basic.state}}</span>
              <i v-if="basic.loading === 'ok'" class="el-icon-loading z-font-size-16"></i>
              <span v-if="basic.loading === 'ok'" class="z-color-red">{{basic.loading_txt}}</span>
              （{{basic.pstate}}）
            </td>
          </tr>
          <tr>
            <td>IP：{{vpsInfo.ip}}</td>
            <td>&nbsp;&nbsp;&nbsp;</td>
            <td class="z-textAlign-right">到期时间：
              <span v-if="vpsInfo.EndTime.indexOf('2111') != 0" >{{vpsInfo.EndTime}}</span>
              <span v-if="vpsInfo.EndTime.indexOf('2111') == 0" class="z-color-red">终身VIP</span>
            </td>
          </tr>
        </table>
        <el-button v-if="basic.start === 'ok'" type="primary" @click="Starting" style="margin-left: 120px;">启动</el-button>
        <el-button v-if="basic.start != 'ok'" type="primary" style="margin-left: 120px;" disabled>启动</el-button>
        <el-button v-if="basic.reset === 'ok'" type="primary" @click="Restart">重启</el-button>
        <el-button v-if="basic.reset != 'ok'" type="primary" disabled>重启</el-button>
        <el-button v-if="basic.close === 'ok'" type="primary" @click="dialogShutdown = true">关机</el-button>
        <el-button v-if="basic.close != 'ok'" type="primary" disabled>关机</el-button>
        <el-button v-if="basic.vnc === 'ok'" type="primary" @click="VncConnect">VNC连接</el-button>
        <el-button v-if="basic.vnc != 'ok'" type="primary" disabled>VNC连接</el-button>
      </div>
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="基本信息" name="first">
          <el-row>
            <el-col :span="24"><div class="row-title">
              基本信息
            </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">名称 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent change-name">
                    {{vpsInfo.vps_name}}
                    <span class="edit-name" title="修改名称" @click="EditName"></span>
                  </div>
                </el-col>
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">备注 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent change-name">
                    {{vpsInfo.vps_remark}}
                    <span class="edit-name" title="修改备注" @click="EditBeizhu"></span>
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">公网IP :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.ip}}
                  </div>
                </el-col>
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">网络类型 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.NET_TYPE}}
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">运行时间 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{runtime}}
                  </div>
                </el-col>
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">操作系统 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.OsType}}
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">创建时间 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.StartTime}}
                  </div>
                </el-col>
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">到期时间 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.EndTime}}
                    &nbsp;&nbsp;
                    <el-button type="primary" @click="Rennew(vps.id,vpsInfo.EndTime,vpsInfo.ip)" style="background-color: #ff7d26;border-color: #ff6f0f;">产品续费</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">配置信息 :</div></el-col>
                <el-col :sm="18" :md="19" :lg="{span:20,pull:1}">
                  <div class="grid-content-small z-padding-left-20-precent">
                    <el-row>
                      <el-col :span="8" class="z-color-666">CPU：<span class="z-color-green z-font-weight-700">{{vpsInfo.CPU}}核</span></el-col>
                      <el-col :span="8" class="z-color-666">公网带宽：<span class="z-color-green z-font-weight-700">{{vpsInfo.NET_WIDTH}}M</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8" class="z-color-666">内存：<span class="z-color-green z-font-weight-700">{{vpsInfo.RAM}}G</span></el-col>
                      <el-col :span="8" class="z-color-666">SSD数据盘：<span class="z-color-green z-font-weight-700">{{vpsInfo.SSD}}G</span></el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <div class="z-margin-all-15-precent" style="width: 320px;height: 250px;margin-top: 1rem;" v-loading="ImgListLoading" element-loading-text="图片加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
                <img :src="ImgUrl" alt="" >
                <p class="z-textAlign-center z-font-size-18 z-lineHeight-30">服务器当前屏幕状态</p>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :span="16">
              <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">操作 :</div></el-col>
              <el-col :sm="18" :md="19" :lg="{span:20,pull:1}">
                <div class="grid-content z-padding-left-20-precent">
                  <el-button type="primary" @click="Shengji(vps.id,vpsInfo.EndTime,vpsInfo.ip,vpsInfo.CPU,vpsInfo.RAM,vpsInfo.SSD,vpsInfo.NET_WIDTH)" style="background-color: #ff7d26;border-color: #ff6f0f;">变更配置</el-button>
                </div>
              </el-col>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="安装操作系统" name="second">
          <div class="alert-warn">
            安装操作系统需要的时间，根据系统类型不同，大约在3-5分钟内安装完毕。
          </div>
          <el-row>
            <el-col :span="24"><div class="row-title">
              安装操作系统
            </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4">
              <div class="grid-content z-padding-left-30-precent z-color-muted">宝塔面板说明 :</div>
              <a class="grid-content z-padding-left-30-precent z-color-a a-underline-link" href="/help/content_1081.html" target="_blank">宝塔面板介绍</a>
            </el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content-small z-padding-left-20-precent change-name">
                <p>内置宝塔面板的系统，安装完毕后，您可以通过访问以下地址来进行初始化服务器。</p>
                <p>Windows用户：<a :href="'http://'+ vpsInfo.ip + ':888'" target="_blank" class="z-color-a a-underline-link">http://{{vpsInfo.ip}}:888</a></p>
                <p>Linux用户：<a :href="'http://'+ vpsInfo.ip + ':8888'" target="_blank" class="z-color-a a-underline-link">http://{{vpsInfo.ip}}:8888</a></p>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">选择操作系统类型 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content z-padding-left-20-precent">
                <el-select v-model="Osnamec" class="z-margin-right-5-precent">
                  <el-option
                    v-for="item in Osname"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="Osid" style="width: 350px">
                  <el-option
                    v-for="item in Oslist"
                    :key="item.sysValue"
                    :label="item.sysName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">操作系统密码 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content-small z-padding-left-20-precent">
                <el-form :model="OspsdForm" :rules="Ospsdrules" ref="OspsdForm" label-width="0" class="psd-form">
                  <el-form-item label="" prop="password" style="margin-top: 10px;margin-bottom: 10px;">
                    <el-input type="password" v-model="OspsdForm.password" style="width: 280px"></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="name" style="margin-bottom: 0">
                    <span class="z-color-red z-font-size-12">请输入8~32位密码(必须包含大写字母小写字母和数字)</span>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">安装方式 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content-small z-padding-left-20-precent">
                <div class="z-margin-bottom-5-precent">
                  <el-radio v-model="Osstyle" label="new" class="z-margin-right-20-precent">全新安装</el-radio> <span class="z-font-size-12 z-color-66-orange">（第一次安装请选择这一项）</span>
                </div>
                <div class="z-margin-bottom-5-precent">
                  <el-radio v-model="Osstyle" label="cpan" class="z-margin-right-20-precent">只安装系统盘</el-radio>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted"></div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content z-padding-left-20-precent">
                <span class="z-font-size-12">为保证您的网站安全，请输入验证码：</span>
                <el-input v-model="Oscaptcha" style="width: 200px"></el-input>
                <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted"></div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content z-padding-left-20-precent">
                <el-button type="primary" v-if="basic.loading != 'ok'" @click="submitForm2('OspsdForm')" style="background-color: #ff7d26;border-color: #ff6f0f;">开始安装</el-button>
                <el-button type="primary" v-if="basic.loading === 'ok'" style="background-color: #ff7d26;border-color: #ff6f0f;opacity: 0.7" disabled>开始安装</el-button>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="安全组" name="security-group">
          <div class="panel-body clearfix">
            <div class="z-margin-bottom-20-precent">
              <span>禁Ping&nbsp;&nbsp;</span>
              <el-switch
                v-model="securityPing"
                @change="changeSecurityPing"
                style="margin-right: 6px"
                active-color="#13ce66"
                inactive-color="#ccc">
              </el-switch>
              <el-select style="width: 100px" v-model="security_key_type" slot="prepend" placeholder="放行端口">

              </el-select>
              <el-input style="width: 200px;" placeholder="端口" v-model="securityPort" class="input-with-select"></el-input>
              <el-input style="width: 200px;" placeholder="备注/说明" v-model="securityRemark" class="input-with-select"></el-input>

              <el-button type="primary" @click="AddSecurity">提交放行</el-button>
              <span>&nbsp;&nbsp;说明:对此服务器操作放行端口，端口填写规则80或者3000-5000</span>
            </div>
            <el-table :data="securityList" highlight-current-row show-header class="table-empty" style="width: 100%;">
              <el-table-column prop="id" label="ID" min-width="100" align="left">
                <template slot-scope="scope">
                  {{scope.row.id}}
                </template>
              </el-table-column>
              <el-table-column prop="startport" label="起始端口" min-width="120" align="left">
                <template slot-scope="scope">
                  {{scope.row.startport}}
                </template>
              </el-table-column>
              <el-table-column prop="endport" label="结束端口" min-width="150" align="left">
                <template slot-scope="scope">
                  {{scope.row.endport}}
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" min-width="150" align="left">
                <template slot-scope="scope">
                  {{scope.row.createTime}}
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注说明" align="center" min-width="100">
                <template slot-scope="scope">
                 {{scope.row.remark}}
                </template>
              </el-table-column>
              <el-table-column prop="caozuo" label="操作" align="center">
                <template slot-scope="scope">
                  <span style="color:red;cursor: pointer" @click="securityDelete(scope.row.id)">删除</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeSecurityChange" :page-size="10" :total="securityTotal" class="pull-left">
            </el-pagination>
            <el-pagination background layout="prev, pager, next" @current-change="handleCurrentSecurityChange" :page-size="securityCount" :total="securityTotal">
            </el-pagination>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="重设密码" name="reset-password">
          <div class="alert-warn">
            <p>1.Windows系统修改密码后大约30秒左右生效。</p>
            <p>2.Linux修改密码需要重新启动两次，大约需要3-5分钟生效</p>
          </div>
          <el-row>
            <el-col :span="24"><div class="row-title">
              修改密码
            </div>
            </el-col>
          </el-row>
          <div class="grid-content z-padding-left-20-precent">
            <el-form :model="psdForm" :rules="psdrules" ref="psdForm" label-width="100px" class="psd-form">
              <el-form-item label="用户名：" prop="name" style="margin-top: 20px">
                <el-input v-model="vpsInfo.adminuser" style="width: 280px" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="输入密码：" prop="password" style="margin-bottom: 10px">
                <el-input type="password" v-model="psdForm.password" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item label="" prop="password" style="margin-bottom: 10px">
                <span class="z-color-red z-font-size-12">请输入8~32位密码(必须包含大写字母小写字母和数字)</span>
              </el-form-item>
              <el-form-item label="确认密码：" prop="checkPass">
                <el-input type="password" v-model="psdForm.checkPass" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" v-if="basic.loading != 'ok'" @click="submitForm('psdForm')" style="background-color: #ff7d26;border-color: #ff6f0f;">确定</el-button>
                <el-button type="primary" v-if="basic.loading === 'ok'" style="background-color: #ff7d26;border-color: #ff6f0f;opacity: 0.7" disabled>确定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="快照管理" name="third">
          <el-button v-show="Kuaizhao.type === 'log'" size="mini" @click="Kuaizhao.type = 'list'">快照列表</el-button>
          <el-button v-show="Kuaizhao.type === 'list'" type="primary" size="mini" style="margin-left: 0">快照列表</el-button>
          <el-button v-show="Kuaizhao.type === 'list'" size="mini" @click="Kuaizhao.type = 'log'">快照日志</el-button>
          <el-button v-show="Kuaizhao.type === 'log'" type="primary" size="mini">快照日志</el-button>
          <el-table v-show="Kuaizhao.type === 'list'"  v-loading="dialogSnaploading" :data="tableSnap" border style="width: 100%;margin-top: 20px">
            <el-table-column prop="type" align="center" label="快照类型">
            </el-table-column>
            <el-table-column prop="state" align="center" label="快照创建状态">
              <template slot-scope="scope">
                <span v-show="scope.row.state.indexOf('正在') == -1" class="z-color-green">{{scope.row.state}}</span>

                <div v-show="scope.row.state.indexOf('正在') !=-1" class="host-uselevel-bar progress">
                  <div class="progress-bar progress-bar-blue" :style="'width: '+ scope.row.rate +'%'">
                  </div>
                  <span class="usage-text" :title="scope.row.state">
										<span class="z-color-66-orange">{{scope.row.rate}}%</span>/<span class="z-color-666">{{scope.row.state}}</span>
										</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="time" align="center" label="快照创建时间">
              <template slot-scope="scope">
                <span class="z-color-green">{{scope.row.time}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="size" align="center" label="快照大小">
              <template slot-scope="scope">
                <span class="z-color-green">{{scope.row.size}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="caozuo" label="操作">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="dialogProtect = true,snapevent = 'back',snaptype = scope.row.type,changeYzm(),Kuaizhao.captcha = ''">还原快照</el-button>
                <el-button v-if="scope.row.type === '用户快照'" type="info" size="mini" @click="dialogProtect = true,snapevent = 'create',snaptype = '用户快照',changeYzm(),Kuaizhao.captcha = ''">创建快照</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-show="Kuaizhao.type === 'log'" :data="tableSnaplog" border style="width: 100%;margin-top: 20px">
            <el-table-column prop="time" align="center" label="时间" width="350">
            </el-table-column>
            <el-table-column prop="event" align="center" label="事件">
              <template slot-scope="scope">
                <span class="z-color-green">{{scope.row.event}}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination v-show="Kuaizhao.type === 'log'" background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total">
          </el-pagination>
        </el-tab-pane>
        <!-- <el-tab-pane label="流量统计" name="fourth">
          <div class="z-margin-bottom-15-precent">
            当前IP：({{vpsInfo.ip}})
          </div>
          <div class="server-monitor-content clearfix list">
            <div class="server-monitor-box">
              <div class="server-monitor-btn">
                <el-button v-show="minubtn === 'max'" size="mini" @click="NetLiuliang('minu','avg')" style="margin-left: 10px">平均</el-button>
                <el-button v-show="minubtn === 'avg'" type="primary" size="mini">平均</el-button>
                <el-button v-show="minubtn === 'avg'" size="mini" @click="NetLiuliang('minu','max')" style="margin-left: 10px">最大</el-button>
                <el-button v-show="minubtn === 'max'" type="primary" size="mini">最大</el-button>
              </div>
              <div id="netMinu" class="charts-container" v-loading="dialogNetMinu">
              </div>
            </div>
            <div class="server-monitor-box">
              <div class="server-monitor-btn">
                <el-button v-show="hourbtn === 'max'" size="mini" @click="NetLiuliang('hour','avg')" style="margin-left: 10px">平均</el-button>
                <el-button v-show="hourbtn === 'avg'" type="primary" size="mini">平均</el-button>
                <el-button v-show="hourbtn === 'avg'" size="mini" @click="NetLiuliang('hour','max')" style="margin-left: 10px">最大</el-button>
                <el-button v-show="hourbtn === 'max'" type="primary" size="mini">最大</el-button>
              </div>
              <div id="netHour" class="charts-container" v-loading="dialogNetHour">

              </div>
            </div>
            <div class="server-monitor-box">
              <div class="server-monitor-btn">
                <el-button v-show="daybtn === 'max'" size="mini" @click="NetLiuliang('day','avg')" style="margin-left: 10px">平均</el-button>
                <el-button v-show="daybtn === 'avg'" type="primary" size="mini">平均</el-button>
                <el-button v-show="daybtn === 'avg'" size="mini" @click="NetLiuliang('day','max')" style="margin-left: 10px">最大</el-button>
                <el-button v-show="daybtn === 'max'" type="primary" size="mini">最大</el-button>
              </div>
              <div id="netDay" class="charts-container" v-loading="dialogNetDay">

              </div>
            </div>
            <div class="server-monitor-box">
              <div class="server-monitor-btn">
                <el-button v-show="monthbtn === 'max'" size="mini" @click="NetLiuliang('month','avg')" style="margin-left: 10px">平均</el-button>
                <el-button v-show="monthbtn === 'avg'" type="primary" size="mini">平均</el-button>
                <el-button v-show="monthbtn === 'avg'" size="mini" @click="NetLiuliang('month','max')" style="margin-left: 10px">最大</el-button>
                <el-button v-show="monthbtn === 'max'" type="primary" size="mini">最大</el-button>
              </div>
              <div id="netMonth" class="charts-container" v-loading="dialogNetMonth">

              </div>
            </div>
          </div>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="cpu使用统计" name="five">
          <div class="z-margin-bottom-15-precent">
            当前IP：({{vpsInfo.ip}})
          </div>
          <div class="server-monitor-content clearfix cpu">
            <div class="server-monitor-box" v-loading="dialogCpu">
              <div id="cpu" class="charts-container">

              </div>
            </div>
          </div>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="磁盘使用统计" name="six">
          <div class="z-margin-bottom-15-precent">
            当前IP：({{vpsInfo.ip}})
          </div>
          <div class="server-monitor-content clearfix cpu">
            <div class="server-monitor-box" v-loading="dialogIops">
              <div id="iops" class="charts-container">

              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="高防管理" name="seven">
          <el-card v-if="vpsInfo.NET_TYPE == '山东高防'" class="gaofang" style="margin-left: 100px;width: 650px" :body-style="{ padding: '0px' }">
            <div class="z-color-fff z-textAlign-center" style="background-color: #3FA0DC;padding: 50px">
              <div class="z-font-size-30">高防独立控制面板设置</div>
              <div class="z-font-size-12" style="margin-top: 15px">发给您用户查看高防服务器信息，方便您开展业务</div>
            </div>
            <div style="padding: 0;">
              <el-row>
                <el-col :span="24">
                  <el-row type="flex" align="middle" class="row-border">
                    <el-col :span="8">
                      <div class="grid-content z-padding-left-60-precent">管理地址：</div>
                    </el-col>
                    <el-col :span="16">
                      <div class="grid-content">
                        <a class="z-color-blue" href="http://103.45.186.18:1234" target="_blank">
                          http://103.45.186.18:1234
                        </a>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" class="row-border">
                    <el-col :span="8">
                      <div class="grid-content z-padding-left-60-precent">设置密码：</div>
                    </el-col>
                    <el-col :span="16">
                      <div class="grid-content">
                        <el-input v-show="gf_pas_eye == false" type="password" autocomplete="new-password" v-model="gfPassword" style="width: 250px">
                          <i slot="suffix" class="eye-open" style="top:16px" @click="gf_pas_eye = true"></i>
                        </el-input>
                        <el-input v-show="gf_pas_eye == true" type="text" v-model="gfPassword" style="width: 250px">
                          <i slot="suffix" class="eye-close" style="top:16px" @click="gf_pas_eye = false"></i>
                        </el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" class="row-border">
                    <el-col :span="8">
                      <div class="grid-content z-padding-left-60-precent">logo地址：</div>
                    </el-col>
                    <el-col :span="10">
                      <div class="grid-content">
                        <el-input v-model="gfLogoUrl" style="width: 250px"></el-input>
                        <p style="line-height: 20px;margin-bottom: 5px;">
                          推荐大小：114 x 27
                        </p>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-button type="primary" @click="gfLogoUrl='https://img.abeiyun.com/img/header_logo.png'">设为默认</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" class="row-border">
                    <el-col :span="8">
                      <div class="grid-content z-padding-left-60-precent"></div>
                    </el-col>
                    <el-col :span="16">
                      <div class="grid-content">
                        <el-button type="primary" @click="setGaoFang">提交</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" class="row-border">
                    <el-col :span="24">
                      <div style="padding: 20px 0 20px 70px">
                        相关说明：
                        <p style="margin-top: 6px">
                          高防独立控制面板仅具备CC防护设置、白名单设置、流量图查看、防护图查看功能
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <el-card v-if="vpsInfo.NET_TYPE != '山东高防'" class="gaofang" style="margin-left: 100px;width: 650px" :body-style="{ padding: '0px' }">
            <div class="z-color-fff z-textAlign-center" style="background-color: #3FA0DC;padding: 50px">
              <div class="z-font-size-30">高防独立控制面板设置</div>
              <div class="z-font-size-12" style="margin-top: 15px">发给您用户查看高防服务器信息，方便您开展业务</div>
            </div>
            <div style="padding: 40px 0px 50px 0px;">
              <h4 class="z-lineHeight-80 z-font-size-20 z-textAlign-center">此业务不是高防服务器业务！</h4>
              <div class="z-textAlign-center">
                <a target="_blank" href="/gfcloud/" class="z-color-blue ">
                  >>点击申请高防服务器
                </a>
              </div>

            </div>
          </el-card>
        </el-tab-pane> -->
      </el-tabs>
      <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
      <xdialog-warning :dialogWarning="dialogWarning" :warningMsg="warningMsg"></xdialog-warning>
      <el-dialog title="云服务器续费" :lock-scroll="false" :visible.sync="dialogXufei" @close="xufeiForm.region = '1'" width="660px">
        <el-form label-width="180px" class="xufei-form">
          <el-form-item label="IP地址：" size="mini">
            <span class="z-font-size-12 z-color-666">{{xufeiForm.ip}}</span>
          </el-form-item>
          <el-form-item label="到期时间：">
            <span class="z-font-size-12 z-color-666">{{xufeiForm.endtime}}</span>
          </el-form-item>
          <el-form-item label="续费时长：">
            <el-select v-model="xufeiForm.region">
              <el-option label="1月" value="1"></el-option>
              <el-option label="2月" value="2"></el-option>
              <el-option label="3月" value="3"></el-option>
              <el-option label="4月" value="4"></el-option>
              <el-option label="5月" value="5"></el-option>
              <el-option label="6月" value="6"></el-option>
              <el-option label="7月" value="7"></el-option>
              <el-option label="8月" value="8"></el-option>
              <el-option label="9月" value="9"></el-option>
              <el-option label="1年" value="12"></el-option>
              <el-option label="2年" value="24"></el-option>
              <el-option label="3年" value="36"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠券：">
            <el-select v-model="xufeiForm.coupon" placeholder="--请选择--" style="width: 300px">
              <el-option
                v-for="item in xufeiForm.yhq"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="续费后到期时间：">
            <span class="z-font-size-12 z-color-666">{{xufeiForm.newtime}}</span>
          </el-form-item>
          <el-form-item label="账户余额：">
            <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{xufeiForm.money}}元</span>
          </el-form-item>
          <el-form-item label="所需费用：">
            <span v-show="xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
            <span v-show="!xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{xufeiForm.price}}.</span>
            <span v-show="!xufeiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogXufei = false">取 消</el-button>
          <el-button type="primary" @click="Renew">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="云服务器变更配置" :lock-scroll="false" :visible.sync="dialogXLevel" @close="shengjiForm.cpu = '',shengjiForm.price = '0'" width="660px">
        <div class="alert-warn">
          服务器升级后，到期时间不变，差价的计算精确到天；<br>升级价格计算公式：(升级配置价格[月] - 原始配置价格[月]) * 12 / 365 * 到期剩余天数。<br>变更配置费用不足10元按10元计算
        </div>
        <el-form label-width="180px" class="xufei-form">
          <el-form-item label="IP地址：">
            <span class="z-font-size-12 z-color-666">{{shengjiForm.ip}}</span>
          </el-form-item>
          <el-form-item label="CPU：">
            <el-select v-model="shengjiForm.cpu" placeholder="--请选择--" style="width: 170px">
              <el-option
                v-for="item in shengjiForm.Cpu"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内存：">
            <el-select v-model="shengjiForm.ram" placeholder="--请选择--" style="width: 170px">
              <el-option
                v-for="item in shengjiForm.Ram"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SSD数据盘：">
            <el-input-number v-model="shengjiForm.ssd" @change="changeSsd" controls-position="right" :step="10" :min="shengjiForm.minssd" :max="1000"></el-input-number>
            <span class="z-font-size-12 z-color-999" style="position: absolute;left: 76px;">GB</span>
          </el-form-item>
          <el-form-item label="公网带宽：">
            <el-input-number v-model="shengjiForm.bandwidth" @change="changeBandwidth" controls-position="right" :min="5" :max="300"></el-input-number>
            <span class="z-font-size-12 z-color-999" style="position: absolute;left: 62px;">Mbps</span>
          </el-form-item>
          <el-form-item label="优惠券：">
            <el-select v-model="shengjiForm.coupon" placeholder="--请选择--" style="width: 300px">
              <el-option
                v-for="item in shengjiForm.yhq"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到期时间：">
            <span class="z-font-size-12 z-color-666">{{shengjiForm.endtime}}</span>
          </el-form-item>
          <el-form-item label="账户余额：">
            <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{shengjiForm.money}}元</span>
          </el-form-item>
          <el-form-item label="所需费用：">
            <span v-show="shengjiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
            <span v-show="!shengjiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{shengjiForm.price}}.</span>
            <span v-show="!shengjiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogXLevel = false">取 消</el-button>
          <el-button type="primary" @click="Level">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="实例名称"
        :visible.sync="dialogEditname"
        top="12%"
        width="500px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          注：修改后方便于管理，不会影响服务器配置，请您放心操作。
        </div>
        <el-form label-width="135px" label-position="right">
          <el-form-item label="IP地址：">
            {{vpsInfo.ip}}
          </el-form-item>
          <el-form-item label="自定义名称：">
            <el-input v-model="remark.name" style="width: 200px"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RemarkEdit">确 定</el-button>
            <el-button @click="dialogEditname = false">取 消</el-button>
          </span>
      </el-dialog>
      <el-dialog
        title="备注"
        :visible.sync="dialogEditBeizhu"
        top="12%"
        width="500px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          注：修改后方便于管理，不会影响服务器配置，请您放心操作。
        </div>
        <el-form label-width="135px" label-position="right">
          <el-form-item label="IP地址：">
            {{vpsInfo.ip}}
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="remark.Bz1" style="width: 200px"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RemarkEdit">确 定</el-button>
            <el-button @click="dialogEditBeizhu = false">取 消</el-button>
          </span>
      </el-dialog>
      <el-dialog
        title="关闭云服务器"
        :visible.sync="dialogShutdown"
        top="18.5%"
        width="500px"
        :lock-scroll=false
        custom-class="dialog">
        <p class="z-margin-bottom-10-precent"><span class="z-font-size-12 z-color-muted z-margin-left-20-precent">请选择您的关机方式：</span></p>
        <div class="z-margin-bottom-5-precent">
          <el-radio v-model="shutdowntype" label="shutdown" class="z-margin-h-20-precent">正常关机</el-radio> <span class="z-font-size-12 z-color-66-orange">[推荐]</span>
        </div>
        <div class="z-margin-bottom-5-precent">
          <el-radio v-model="shutdowntype" label="close" class="z-margin-h-20-precent">强制关机</el-radio> <span class="z-font-size-12 z-color-muted">强制关机可能会导致未保存的数据丢失</span>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShutdown = false">取 消</el-button>
        <el-button type="primary" @click="ShutDown">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="管理终端"
        :visible.sync="dialogVnc"
        top="12%"
        width="450px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          注：默认为初始系统密码，如无法连接请修改连接密码
        </div>
        <div class="z-textAlign-center">
          <el-button size="medium" type="primary" style="width: 160px;">连接管理终端</el-button>
          <br>
          <br>
          <el-button size="medium" type="primary" plain style="width: 160px;">修改连接密码</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="操作保护"
        :visible.sync="dialogProtect"
        top="18.5%"
        width="660px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div v-if="snapevent === 'back'" class="alert-warn">
          还原快照会覆盖服务器现有数据，确认还原请输入验证码继续操作，不需要还原请取消
        </div>
        <div v-if="snapevent === 'create'" class="alert-warn">
          创建快照会覆盖现有快照，确认创建请输入验证码继续操作，不需要创建请取消
        </div>
        <span class="z-font-size-12">为保证您的网站安全，请输入验证码：</span>
        <el-input v-model="Kuaizhao.captcha" style="width: 200px"></el-input>
        <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="Snap">确 定</el-button>
          <el-button @click="dialogProtect = false">取 消</el-button>
        </span>
      </el-dialog>
      <!--<el-dialog title="创建安全组规则" :lock-scroll="false" :visible.sync="dialogSecurity" @close="dialogSecurity = false" width="660px">
        <el-form label-width="120px" class="xufei-form">
          <el-form-item label="协议栈：">

            <el-select v-model="securityForm.stack">
              <el-option label="IPv4" value="IPv4"></el-option>
              <el-option label="IPv6" value="IPv6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规则方向：">
            <el-select v-model="securityForm.direction">
              <el-option label="入方向" value="1"></el-option>
              <el-option label="出方向" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="协议类型：">
            <el-select v-model="securityForm.type">
              <el-option label="TCP" value="TCP"></el-option>
              <el-option label="UDP" value="UDP"></el-option>
              <el-option label="ICMP" value="ICMP"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="端口范围：">
            <el-input style="width: 250px" v-model="securityForm.limit" placeholder="请设置端口范围"></el-input>
            <br>
            <span>取值范围从1到65535;多个端口设置格式例如"1-20"，单个端口设置格式例如"80"</span>
          </el-form-item>
          <el-form-item label="授权网络：">
            <el-input style="width: 250px" v-model="securityForm.net" placeholder="请设置授权网络"></el-input>
            <br>
            <span>请根据实际场景设置授权对象的CIDR，另外，0.0.0.0/0代表允许所有IPv4的访问,:/0代表允许所有IPv6的访问,设置时请务必谨慎</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogSecurity = false">取 消</el-button>
          <el-button type="primary" @click="AddSecurity">确 定</el-button>
        </div>
      </el-dialog>-->
    </div>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import VpsService from 'business/VpsService.js'
  import userService from 'business/userService.js'
  import renewService from 'business/renewService.js'
  import upgradeService from 'business/upgradeService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import XdialogWarning from 'components/commons/XdialogWarning.vue'
  import echarts from 'echarts/lib/echarts'
  export default {
    data () {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value !== this.psdForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        listLoading:false,
        ImgListLoading:false,
        dialogLoading:false,
        dialogSnaploading:false,
        dialogWarning:false,
        dialogEditname:false,
        dialogEditBeizhu:false,
        dialogNetMinu:false,
        dialogNetHour:false,
        dialogNetDay:false,
        dialogNetMonth:false,
        dialogCpu:false,
        dialogIops:false,
        dialogVnc:false,
        dialogShutdown:false,
        dialogProtect:false,
        dialogXufei:false,
        dialogXLevel:false,
        warningMsg:'',
        activeName:'first',
        vps:{},
        vpsInfo:{
          EndTime:''
        },
        remark:{
          name:'',
          Bz1:''
        },
        xufeiForm:{
          id:'',
          ip:'',
          endtime:'',
          region: '1',
          coupon:'',
          yhq:[],
          newtime:'',
          price:'',
          loading:false,
          money:''
        },
        shengjiForm:{
          ip:'',
          cpu:'',
          Cpu:[
            {
              value: '1',
              label: '1核'
            },
            {
              value: '2',
              label: '2核'
            },
            {
              value: '4',
              label: '4核'
            },
            {
              value: '8',
              label: '8核'
            },
            {
              value: '16',
              label: '16核'
            },
          ],
          ram:'',
          Ram:[
            {
              value: '1',
              label: '1G'
            },
            {
              value: '2',
              label: '2G'
            },
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
          ],
          ssd:1,
          minssd:1,
          bandwidth:1,
          minbandwidth:1,
          coupon:'',
          yhq:[],
          endtime:'',
          price:'0',
          loading:false,
          money:''
        },
        runtime:'',
        basic:{
          pstate:'',
          state:'',
          close: '',
          reset: '',
          start: '',
          vnc: '',
          loading:'',
          loading_txt:''
        },
        ImgUrl:'',
        timer: null,
        minubtn:'avg',
        hourbtn:'avg',
        daybtn:'avg',
        monthbtn:'avg',
        session_id:'',
        shutdowntype:'shutdown',
        Osname:{},
        Osdata:{},
        Oslist:{},
        Osnamec:'Windows',
        Osid:'',
        Osstyle:'new',
        password:'',
        Oscaptcha:'',
        psdForm:{
          password:'',
          checkPass:'',
        },
        OspsdForm:{
          password:''
        },
        Kuaizhao:{
          type:'list',
          captcha:''
        },
        tableSnap:[],
        tableSnaplog:[],
        snapevent:'',
        snaptype:'',
        psdrules:{
          password: [
            { required: true, message: '密码格式不正确', trigger: 'blur' },
            { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,32}$/ , message: '密码格式不正确' },
          ],
          checkPass: [
            { validator: validatePass, trigger: 'blur' }
          ]
        },
        Ospsdrules:{
          password: [
            { required: true, message: '密码格式不正确', trigger: 'blur' },
            { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,32}$/ , message: '密码格式不正确' },
          ]
        },
        captcha:'https://api.abeiyun.com/www/yzm.php?rnd='+Math.random(),
        total:0,
        page:1,
        phone:'',
        pas_eye:false,
        gfPassword:'',
        gfLogoUrl:'',
        gf_pas_eye:false,

        securitySearch:'',
        securityPing:false,
        securityPort:'',
        securityRemark:'',
        securityCount:10,
        securityTotal:0,
        securityPage:1,
        security_key_type:'放行端口',
        securityList:[

        ],
        dialogSecurity:false,
        securityForm:{
          stack:'IPv4',direction:'1',type:'TCP',limit:'',net:''
        }
      }
    },
    components:{
      XdialogLoading,
      XdialogWarning
    },
    props:{
      hide:Boolean
    },
    created() {
      this.timer = setInterval(() => {
        this.VpsState()
        if(this.activeName === 'first'){
          this.getRunTime()
          this.getVpsImg()
        }
      }, 10000)
    },
    mounted() {
      this.config()
    },
    beforeDestroy() {
      if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
        clearInterval(this.timer); //关闭
      }
      if(this.timer3) { //如果定时器还在运行 或者直接关闭，不用判断
        clearInterval(this.timer3); //关闭
      }
    },
    computed: {
      state() {
        if(this.snaptype === '用户快照'){
          return this.tableSnap[0].state
        }
        if(this.snaptype === '系统快照'){
          return this.tableSnap[1].state
        }
      },
      region() {
        return this.xufeiForm.region
      },
      coupon() {
        return this.xufeiForm.coupon
      },
      coupon2() {
        return this.shengjiForm.coupon
      },
      cpu() {
        return this.shengjiForm.cpu
      },
      ram() {
        return this.shengjiForm.ram
      },
    },
    watch:{
      activeName(val){
        if(val === 'second'){
          this.vps_oslist()
        }
        if(val === 'third'){
          this.kz_list()
          this.kz_log_list()
        }
        if(val === 'fourth'){
          this.NetLiuliang('all','avg')
        }
        if(val === 'five'){
          this.CpuLiuliang()
        }
        if(val === 'six'){
          this.IopsLiuliang()
        }
        if(val === 'security-group'){
          this.SearchSecurity()
        }
      },
      Osnamec(){
        this.Oslist = this.Osdata.filter(item => {
          return item.win_linux === this.Osnamec
        })
        this.Osid = this.Oslist[0].id
      },
      region(){
        this.getPrice()
      },
      coupon(){
        this.getPrice()
      },
      coupon2(){
        this.levelPrice()
      },
      cpu(val,oldval){
        if(val === '1'){
          this.shengjiForm.Ram = [
            {
              value: '1',
              label: '1G'
            },
            {
              value: '2',
              label: '2G'
            },
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
          ]
        }
        if(val === '2'){
          this.shengjiForm.Ram = [
            {
              value: '2',
              label: '2G'
            },
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
            {
              value: '16',
              label: '16G'
            },
          ]
        }
        if(val === '4'){
          this.shengjiForm.Ram = [
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
            {
              value: '16',
              label: '16G'
            },
            {
              value: '32',
              label: '32G'
            },
          ]
        }
        if(val === '8'){
          this.shengjiForm.Ram = [
            {
              value: '8',
              label: '8G'
            },
            {
              value: '16',
              label: '16G'
            },
            {
              value: '32',
              label: '32G'
            },
            {
              value: '64',
              label: '64G'
            },
          ]
        }
        if(val === '16'){
          this.shengjiForm.Ram = [
            {
              value: '16',
              label: '16G'
            },
            {
              value: '32',
              label: '32G'
            },
            {
              value: '64',
              label: '64G'
            },
          ]
        }
        if(oldval != '' && val != ''){
          this.shengjiForm.ram = this.shengjiForm.Ram[0].value
          this.levelPrice()
        }
      },
      ram(val,oldval){
        this.levelPrice()
      },
    },
    methods:{
      async config() {
        this.vps = sessionStorage.getItem('vps') ? JSON.parse(sessionStorage.getItem('vps')) : {'id': this.$route.params.id}
        this.VpsQuery()
        this.VpsState()
        this.getRunTime()
        this.getVpsImg()
      },
      backToVps(){
        this.$router.push('/serverList')
      },
      async VpsQuery() {
        this.listLoading = true
        let data = 'cmd=vps_list'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.vpsInfo = vueData.msg.content[0]
          this.session_id = vueData.msg.session_id
          this.listLoading = false
        }else {
          this.listLoading = false
          this.dialogWarning = true
          this.warningMsg = vueData.msg
        }
      },
      Interval(){
        setInterval(() => {
          this.VpsState()
          this.getRunTime()
          this.getVpsImg()
        }, 10000)
      },
      async VpsState() {
        let data = 'cmd=get_vps_state'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000') {
          this.basic.state = vueData.msg
          this.basic.pstate = vueData.Pstate
          this.basic.close = vueData.close
          this.basic.reset = vueData.reset
          this.basic.start = vueData.start
          this.basic.vnc = vueData.vnc
          this.basic.loading = vueData.loading
          this.basic.loading_txt = vueData.loading_txt
        }else {
          this.$toast('刷新试一下','fail')
        }
      },
      async getRunTime() {
        let data = 'cmd=getRunTime'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.runtime = vueData.msg
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async getVpsImg() {
        this.ImgListLoading = true
        let data = 'cmd=getVpsImg'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.ImgUrl = vueData.img.split('<img src=\'')[1].split('\' />')[0]
          this.ImgListLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async Starting(){
        MessageBox.confirm('是否确定启动？', '启动云服务器', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=vps_control'+
            '&id='+ this.vps.id +
            '&cmd_type=start'
          let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.VpsState()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });

      },
      async Restart(){
        MessageBox.confirm('强制重启可能会导致未保存的数据丢失', '重启服务器', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'info'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=vps_control'+
            '&id='+ this.vps.id +
            '&cmd_type=reset'
          let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.VpsState()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });

      },
      async ShutDown(){
        this.dialogLoading = true
        let data;
        if(this.shutdowntype === 'close'){
          data = 'cmd=vps_control'+
            '&id='+ this.vps.id +
            '&cmd_type=close'
        }
        if(this.shutdowntype === 'shutdown'){
          data = 'cmd=vps_control'+
            '&id='+ this.vps.id +
            '&cmd_type=shutdown'
        }
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogShutdown = false
              self.VpsState()
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      EditName(){
        this.remark.Bz1 = this.vpsInfo.vps_remark
        this.remark.name = this.vpsInfo.vps_name
        this.dialogEditname = true
      },
      EditBeizhu(){
        this.remark.Bz1 = this.vpsInfo.vps_remark
        this.remark.name = this.vpsInfo.vps_name
        this.dialogEditBeizhu = true
      },
      async RemarkEdit() {
        this.dialogLoading = true
        let data = 'cmd=remark_edit'+
          '&id='+ this.vpsInfo.id +
          '&vps_remark='+ this.remark.Bz1 +
          '&vps_name='+ this.remark.name
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogEditname = false
              self.dialogEditBeizhu = false
              self.VpsQuery()
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async NetLiuliang(btn,type) {
        if(btn === 'minu'){
          if(type === 'avg'){
            this.minubtn = 'avg'
          }
          if(type === 'max'){
            this.minubtn = 'max'
          }
        }
        if(btn === 'hour'){
          if(type === 'avg'){
            this.hourbtn = 'avg'
          }
          if(type === 'max'){
            this.hourbtn = 'max'
          }
        }
        if(btn === 'day'){
          if(type === 'avg'){
            this.daybtn = 'avg'
          }
          if(type === 'max'){
            this.daybtn = 'max'
          }
        }
        if(btn === 'month'){
          if(type === 'avg'){
            this.monthbtn = 'avg'
          }
          if(type === 'max'){
            this.monthbtn = 'max'
          }
        }
        if(btn === 'all'){
          this.dialogNetMinu = true
          this.dialogNetHour = true
          this.dialogNetDay = true
          this.dialogNetMonth = true
        }
        let data = 'cmd=sys_report' +
          '&id='+ this.vps.id +
          '&cmd_type=net'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000' ) {
          //计算单位
          let minuavgunit = this.bpsToSize2(vueData.minu.length > 0 ? (this.getiavgMax(vueData.minu) > this.getoavgMax(vueData.minu) ? this.getiavgMax(vueData.minu) : this.getoavgMax(vueData.minu)) : '')
          let minumaxunit = this.bpsToSize2(vueData.minu.length > 0 ? (this.getimaxMax(vueData.minu) > this.getomaxMax(vueData.minu) ? this.getimaxMax(vueData.minu) : this.getomaxMax(vueData.minu)) : '')

          let houravgunit = this.bpsToSize2(vueData.hour.length > 0 ? (this.getiavgMax(vueData.hour) > this.getoavgMax(vueData.hour) ? this.getiavgMax(vueData.hour) : this.getoavgMax(vueData.hour)) : '')
          let hourmaxunit = this.bpsToSize2(vueData.hour.length > 0 ? (this.getimaxMax(vueData.hour) > this.getomaxMax(vueData.hour) ? this.getimaxMax(vueData.hour) : this.getomaxMax(vueData.hour)) : '')

          let dayavgunit = this.bpsToSize2(vueData.day.length > 0 ? (this.getiavgMax(vueData.day) > this.getoavgMax(vueData.day) ? this.getiavgMax(vueData.day) : this.getoavgMax(vueData.day)) : '')
          let daymaxunit = this.bpsToSize2(vueData.day.length > 0 ? (this.getimaxMax(vueData.day) > this.getomaxMax(vueData.day) ? this.getimaxMax(vueData.day) : this.getomaxMax(vueData.day)) : '')

          let monthavgunit = this.bpsToSize2(vueData.month.length > 0 ? (this.getiavgMax(vueData.month) > this.getoavgMax(vueData.month) ? this.getiavgMax(vueData.month) : this.getoavgMax(vueData.month)) : '')
          let monthmaxunit = this.bpsToSize2(vueData.month.length > 0 ? (this.getimaxMax(vueData.month) > this.getomaxMax(vueData.month) ? this.getimaxMax(vueData.month) : this.getomaxMax(vueData.month)) : '')
          let netMinu = echarts.init(document.getElementById('netMinu'));
          let netHour = echarts.init(document.getElementById('netHour'));
          let netDay = echarts.init(document.getElementById('netDay'));
          let netMonth = echarts.init(document.getElementById('netMonth'));
          let optionMinu = {
            title: {
              text: '分钟带宽统计图' + '(单位:'+ (type ==='avg' ? minuavgunit : minumaxunit) +')',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14,
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.minu.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ (type ==='avg' ? minuavgunit : minumaxunit)
              }
            },
            series: [
              {
                name:'流入带宽',
                data: vueData.minu.map((item, index) => {
                  if(type ==='avg'){
                    return {
                      value:this.bpsToSize(item.i_f_all_avg,minuavgunit),
                      unit:minuavgunit
                    }
                  }
                  if(type ==='max'){
                    return {
                      value:this.bpsToSize(item.i_f_all_max,minumaxunit),
                      unit:minumaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: vueData.minu.map((item, index) => {
                  if(type === 'avg'){
                    return {
                      value:this.bpsToSize(item.o_f_all_avg,minuavgunit),
                      unit:minuavgunit
                    }
                  }
                  if(type === 'max'){
                    return {
                      value:this.bpsToSize(item.o_f_all_max,minumaxunit),
                      unit:minumaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          let optionHour = {
            title: {
              text: '小时带宽统计图' + '(单位:'+ (type ==='avg' ? houravgunit : hourmaxunit) +')',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.hour.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ (type ==='avg' ? houravgunit : hourmaxunit)
              }
            },
            series: [
              {
                name:'流入带宽',
                data: vueData.hour.map((item, index) => {
                  if(type ==='avg'){
                    return {
                      value:this.bpsToSize(item.i_f_all_avg,houravgunit),
                      unit:houravgunit
                    }
                  }
                  if(type ==='max'){
                    return {
                      value:this.bpsToSize(item.i_f_all_max,hourmaxunit),
                      unit:hourmaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: vueData.hour.map((item, index) => {
                  if(type === 'avg'){
                    return {
                      value:this.bpsToSize(item.o_f_all_avg,houravgunit),
                      unit:houravgunit
                    }
                  }
                  if(type === 'max'){
                    return {
                      value:this.bpsToSize(item.o_f_all_max,hourmaxunit),
                      unit:hourmaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          let optionDay = {
            title: {
              text: '日带宽统计图' + '(单位:'+ (type ==='avg' ? dayavgunit : daymaxunit) +')',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.day.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ (type ==='avg' ? dayavgunit : daymaxunit)
              }
            },
            series: [
              {
                name:'流入带宽',
                data: vueData.day.map((item, index) => {
                  if(type ==='avg'){
                    return {
                      value:this.bpsToSize(item.i_f_all_avg,dayavgunit),
                      unit:dayavgunit
                    }
                  }
                  if(type ==='max'){
                    return {
                      value:this.bpsToSize(item.i_f_all_max,daymaxunit),
                      unit:daymaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: vueData.day.map((item, index) => {
                  if(type === 'avg'){
                    return {
                      value:this.bpsToSize(item.o_f_all_avg,dayavgunit),
                      unit:dayavgunit
                    }
                  }
                  if(type === 'max'){
                    return {
                      value:this.bpsToSize(item.o_f_all_max,daymaxunit),
                      unit:daymaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          let optionMonth = {
            title: {
              text: '月带宽统计图' + '(单位:'+ (type ==='avg' ? monthavgunit : monthmaxunit) +')',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.month.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ (type ==='avg' ? monthavgunit : monthmaxunit)
              }
            },
            series: [
              {
                name:'流入带宽',
                data: vueData.month.map((item, index) => {
                  if(type ==='avg'){
                    return {
                      value:this.bpsToSize(item.i_f_all_avg,monthavgunit),
                      unit:monthavgunit
                    }
                  }
                  if(type ==='max'){
                    return {
                      value:this.bpsToSize(item.i_f_all_max,monthmaxunit),
                      unit:monthmaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: vueData.month.map((item, index) => {
                  if(type === 'avg'){
                    return {
                      value:this.bpsToSize(item.o_f_all_avg,monthavgunit),
                      unit:monthavgunit
                    }
                  }
                  if(type === 'max'){
                    return {
                      value:this.bpsToSize(item.o_f_all_max,monthmaxunit),
                      unit:monthmaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          if(btn === 'minu'){
            netMinu.setOption(optionMinu)
          }
          if(btn === 'hour'){
            netHour.setOption(optionHour)
          }
          if(btn === 'day'){
            netDay.setOption(optionDay)
          }
          if(btn === 'month'){
            netMonth.setOption(optionMonth)
          }
          if(btn === 'all'){
            netMinu.setOption(optionMinu)
            this.dialogNetMinu = false
            netHour.setOption(optionHour)
            this.dialogNetHour = false
            netDay.setOption(optionDay)
            this.dialogNetDay = false
            netMonth.setOption(optionMonth)
            this.dialogNetMonth = false
          }
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async CpuLiuliang() {
        this.dialogCpu = true
        let data = 'cmd=sys_report' +
          '&id='+ this.vps.id +
          '&cmd_type=cpu'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000' ) {
          let Cpu = echarts.init(document.getElementById('cpu'));
          let option = {
            title: {
              text: 'CPU使用统计图',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14,
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                return params[0].name + '<br />' + 'CPU使用情况：' + params[0].value + '%'
              }
            },
            color:['#7CB5EC'],
            legend: {
              data:['CPU使用情况'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.msg.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.logtime
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ '%'
              }
            },
            series: [
              {
                name:'CPU使用情况',
                data: vueData.msg.map((item, index) => {
                  return item.cpu
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
            ]
          };
          Cpu.setOption(option)
          this.dialogCpu = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async IopsLiuliang() {
        this.dialogIops = true
        let data = 'cmd=sys_report' +
          '&id='+ this.vps.id +
          '&cmd_type=cpu'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000' ) {
          let Iops = echarts.init(document.getElementById('iops'));
          let option = {
            title: {
              text: '磁盘使用统计图',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14,
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '写入IOPS：' + params[0].value + '<br />' + '读取IOPS：' + params[1].value;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '写入IOPS'){
                    return params[0].name + '<br />' + '写入IOPS：' + params[0].value;
                  }
                  if(params[0].seriesName === '读取IOPS'){
                    return params[0].name + '<br />' + '读取IOPS：' + params[0].value;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['写入IOPS','读取IOPS'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.msg.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.logtime
              }),
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                name:'写入IOPS',
                data: vueData.msg.map((item, index) => {
                  return item.writeiops
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'读取IOPS',
                data: vueData.msg.map((item, index) => {
                  return item.readiops
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          Iops.setOption(option)
          this.dialogIops = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.pwd_reset()
          } else {
            return false;
          }
        });
      },
      async submitForm2(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.os_setup()
          } else {
            return false;
          }
        });
      },
      async pwd_reset() {
        this.dialogLoading = true
        let data = 'cmd=pwd_reset'+
          '&id='+ this.vps.id +
          '&password=' + this.psdForm.password
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.psdForm.password =''
              self.psdForm.checkPass =''
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async vps_oslist() {
        let data = 'cmd=vps_oslist'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          let hash = {};
          this.Osname = vueData.msg.map((item, index) => {
            return {
              value:item.win_linux,
              label:item.win_linux
            }
          }).reduceRight((item, next) => {
            hash[next.value] ? '' : hash[next.value] = true && item.push(next);
            return item
          }, []);
          this.Osdata = vueData.msg
          this.Oslist = this.Osdata.filter(item => {
            return item.win_linux === this.Osnamec
          })
          this.Osid = this.Oslist[0].id
        }else {
          this.$toast('服务器繁忙，请重试','fail')
        }
      },
      changeYzm() {
        this.captcha = 'https://api.abeiyun.com/www/yzm.php?rnd='+Math.random()
      },
      async os_setup() {
        this.dialogLoading = true
        let data = 'cmd=os_setup'+
          '&id='+ this.vps.id +
          '&img_yzm=' + this.Oscaptcha +
          '&os_id=' + this.Osid +
          '&password=' + this.OspsdForm.password +
          '&setup_type=' + this.Osstyle
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.OspsdForm.password = ''
          this.changeYzm()
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogShutdown = false
              self.VpsState()
          }})
        }else {
          this.OspsdForm.password = ''
          this.changeYzm()
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      getListIng() {
        // 这里是一个http的异步请求
        if(this.state){
          if (this.state.indexOf('正在') !=-1 && !this.timeOut) {
            let _this = this;
            this.timeOut = setTimeout(() => {
              this.kz_list()
              _this.getListIng()
            }, 2000);
          } else {
            this.timeOut = '';
          }
        }
      },
      async kz_list() {
        let data = 'cmd=kz_list'+
                   '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.tableSnap = vueData.msg.map(item => {
            let name = '用户快照'
            if(item.bak_type === 'user'){
              name = '用户快照'
            }
            if(item.bak_type === 'sys'){
              name = '系统快照'
            }
            return {
              type:name,
              state:item.bak_state,
              time:item.bak_time,
              size:item.bak_size ? item.bak_size + 'G' : '',
              rate:item.bak_rate,
            }
          })
          this.getListIng()
        }else {
          this.$toast('服务器繁忙，请重试','fail')
        }
      },
      async kz_log_list() {
        let data = 'cmd=kz_log_list'+
                   '&count=10'+
                   '&page='+ this.page +
                   '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.tableSnaplog = vueData.msg.content.map(item => {
            return {
              time:item.do_time,
              event:item.do_result
            }
          })
        }else {
          this.$toast('服务器繁忙，请重试','fail')
        }
      },
      async Snap() {
        this.dialogProtect = false
        this.dialogLoading = true
        setTimeout(() => {
          this.dialogLoading = false
          this.kz_list()
        },5000)
        let data;
        if(this.snapevent === 'create'){
          data = 'cmd=kz_creat'+
                 '&id='+ this.vps.id +
                 '&img_yzm='+ this.Kuaizhao.captcha
        }
        if(this.snapevent === 'back'){
          let bak_type = this.snaptype === '用户快照' ? 'user' : 'sys'
          data = 'cmd=kz_reback'+
            '&id='+ this.vps.id +
            '&img_yzm='+ this.Kuaizhao.captcha +
            '&bak_type='+bak_type
        }
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000') {
          if(vueData.response != 200){
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.kz_log_list()
      },
      bpsToSize(bps,unit) {
        if (bps === 0) return '0';
        bps = bps*8
        let k = 1024,i = 0;
        if(unit == 'bps'){
          i = 0
        }
        if(unit == 'Kbps'){
          i = 1
        }
        if(unit == 'Mbps'){
          i = 2
        }
        return (bps / Math.pow(k, i)) > 1 ? (bps / Math.pow(k, i)).toPrecision(4) : (bps / Math.pow(k, i)).toFixed(4);
      },
      bpsToSize2(bps) {
        if (bps === '') return '';
        if (bps === 0) return 'bps';
        bps = bps*8
        var k = 1024, // or 1024
          sizes = ['bps','Kbps', 'Mbps'],
          i = Math.floor(Math.log(bps) / Math.log(k));

        return sizes[i];
      },
      getiavgMax(arr){
        let max = arr[0].i_f_all_avg
        for(let x in arr){
          if(arr[x].i_f_all_avg > max){
            max = arr[x].i_f_all_avg
          }
        }
        return max
      },
      getimaxMax(arr){
        let max = arr[0].i_f_all_max
        for(let x in arr){
          if(arr[x].i_f_all_max > max){
            max = arr[x].i_f_all_max
          }
        }
        return max
      },
      getoavgMax(arr){
        let max = arr[0].o_f_all_avg
        for(let x in arr){
          if(arr[x].o_f_all_avg > max){
            max = arr[x].o_f_all_avg
          }
        }
        return max
      },
      getomaxMax(arr){
        let max = arr[0].o_f_all_max
        for(let x in arr){
          if(arr[x].o_f_all_max > max){
            max = arr[x].o_f_all_max
          }
        }
        return max
      },
      VncConnect() {
        window.open('http://vnc.abeiyun.com/admin-websocket.html?id='+window.btoa(this.session_id)+'&ip='+window.btoa(this.vpsInfo.ip))
      },
      Rennew(id,endtime,ip) {
        this.xufeiForm.id = id
        this.xufeiForm.endtime = endtime
        this.xufeiForm.ip = ip
        this.dialogXufei = true
        this.couponInfo()
        this.getPrice()
      },
      async Shengji(id,endtime,ip,cpu,ram,ssd,bandwidth) {
        this.shengjiForm.id = id
        this.shengjiForm.endtime = endtime
        this.shengjiForm.ip = ip
        this.shengjiForm.cpu = cpu.replace('核','')
        this.shengjiForm.ram = ram.replace('G','')
        this.shengjiForm.ssd = Number(ssd.replace('G',''))
        this.shengjiForm.minssd = Number(ssd.replace('G',''))
        this.shengjiForm.bandwidth = Number(bandwidth.replace('M',''))
        this.shengjiForm.minbandwidth = Number(bandwidth.replace('M',''))
        this.dialogXLevel = true
        this.couponInfo()
      },
      async getPrice() {
        this.xufeiForm.loading = true
        let data = 'cmd=renew'+
          '&yewu_type=vps'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=getprice'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.xufeiForm.loading = false
          this.xufeiForm.name = vueData.pname
          this.xufeiForm.ftp = vueData.ftp_user
          this.xufeiForm.newtime = vueData.endtime
          this.xufeiForm.price = vueData.price
        }else {
          let self = this
          this.$dialog({type:'error', info: vueData.msg, click () {
              self.xufeiForm.coupon = ''
            }})
        }
      },
      async couponInfo() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(state.code === '000' ) {
          this.xufeiForm.money = vueData.msg.money
          this.shengjiForm.money = vueData.msg.money
          this.shengjiForm.yhq = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
          this.shengjiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async Renew() {
        this.dialogLoading = true
        let data = 'cmd=renew'+
          '&yewu_type=vps'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=renew'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogXufei = false
              self.VpsQuery()
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      changeSsd(ssd) {
        this.shengjiForm.ssd = ssd
        this.levelPrice()
      },
      changeBandwidth(bandwidth) {
        this.shengjiForm.bandwidth = bandwidth
        this.levelPrice()
      },
      async levelPrice() {
        this.shengjiForm.loading = true
        let data = 'cmd=vps_price'+
          '&yewu_id='+ this.shengjiForm.id +
          '&CPU='+ this.shengjiForm.cpu +
          '&RAM='+ this.shengjiForm.ram +
          '&SSD='+ this.shengjiForm.ssd +
          '&NET_WIDTH='+ this.shengjiForm.bandwidth +
          '&yhq_id='+ this.shengjiForm.coupon
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.shengjiForm.loading = false
          this.shengjiForm.price = vueData.msg
        }else if(vueData.msg === '当前配置没有更改！'){
          this.shengjiForm.loading = false
          this.shengjiForm.price = 0
        } else {
          this.shengjiForm.loading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async Level() {
        this.dialogLoading = true
        let data = 'cmd=vps_upgrade'+
          '&yewu_id='+ this.shengjiForm.id +
          '&CPU='+ this.shengjiForm.cpu +
          '&RAM='+ this.shengjiForm.ram +
          '&SSD='+ this.shengjiForm.ssd +
          '&NET_WIDTH='+ this.shengjiForm.bandwidth+
          '&yhq_id='+ this.shengjiForm.coupon
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogXLevel = false
              self.VpsQuery()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async setGaoFang() {
        this.dialogLoading = true;
        let self = this
        let data = 'cmd=set_gf_pwd'+
          '&id='+ this.vps.id +
          '&password='+ this.gfPassword +
          '&logo='+ this.gfLogoUrl;
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.$dialog({type:'success', info: vueData.msg, click () {self.VpsQuery()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async SearchSecurity() {
        let data ='cmd=AclControl_List'+
          '&vpsIp='+ this.vpsInfo.ip
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.securityTotal = vueData.msg.allcount
          this.securityList = vueData.msg.content
          if(vueData.denyping){
            this.securityPing = vueData.denyping
          }else{
            this.securityPing = false
          }
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async changeSecurityPing() {
        let data = 'cmd=setping'+
          '&vpsIp='+ this.vpsInfo.ip +
          '&denyping='+ (this.securityPing == true ? 'true' : 'false')
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData) {
          let self = this;
          this.$dialog({type:'success', info: '切换成功！', click () {self.SearchSecurity()}})
        }else {
          this.$dialog({type:'error', info: '切换失败！', click () {}})
        }
      },
      async AddSecurity() {
        let data = 'cmd=AclControl'+
          '&vpsIp='+ this.vpsInfo.ip +
          '&port='+ this.securityPort +
          '&remark='+ this.securityRemark
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData) {
          this.securityPort = '';
          this.securityRemark = '';
          let self = this;
          this.$dialog({type:'success', info: '添加成功！', click () {self.SearchSecurity()}})
        }else {
          this.$dialog({type:'error', info: '添加失败！', click () {}})
        }
      },
      handleCurrentSecurityChange(val) {
        this.securityPage = val;
        this.SearchSecurity()
      },
      handleSizeSecurityChange(val) {
        this.securityCount = val
        this.SearchSecurity()
      },
      async securityDelete(id) {
        MessageBox.confirm('确认删除?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=AclControl_Delete'+
            '&vpsIp='+ this.vpsInfo.ip +
            '&id='+ id;
          let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
          if(vueData) {
            let self = this
            this.$dialog({type:'success', info: '删除成功！', click () {self.SearchSecurity()}})
          }else {
            this.$dialog({type:'error', info: '删除失败！', click () {}})
          }
        }).catch(() => {

        });
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
    background-color: #fff;
  }
  .page-main { border: 0}
  .panel-heading { padding: 5px 0 0 0; }
  .hideleft { margin-left: 80px; }
  .server-header {
    height: 96px;
    margin-top: 18px;
    margin-bottom: 30px;
    background-repeat: no-repeat;
    background-position: left center;
  }
  .server-windows {
    background-image: url(../../assets/imgs/windows.png);
  }
  .server-windows.server-close {
    background-image: url(../../assets/imgs/windows-close.png);
  }
  .server-centos {
    background-image: url(../../assets/imgs/centos.png);
  }
  .server-centos.server-close {
    background-image: url(../../assets/imgs/centos-close.png);
  }
  .server-ubuntu {
    background-image: url(../../assets/imgs/ubuntu.png);
  }
  .server-ubuntu.server-close {
     background-image: url(../../assets/imgs/ubuntu-close.png);
  }
  .server-header > p {
    margin: 10px 0;
    font-size: 12px;
    color: #a0a2a3;
  }
  .server-header > p > span {
    margin-right: 25px;
  }
  .server-header-table {
    margin-left: 120px;
  }
  .server-header-table td {
    padding-bottom: 8px;
    font-size: 12px;
    color: #a0a2a3;
  }
  .server-header-table .z-color-green-state {
    color:#29cc7a;
  }
  .server-header .state-icon {
    display: inline;
    padding-left: 22px;
    font-size: 12px;
  }
  .state-icon {
    background: no-repeat left center;
  }
  .server-state-run {
    background-image: url(../../assets/imgs/server_state_run.png);
    color: #29cc7a;
  }
  .server-state-stop {
    background-image: url(../../assets/imgs/server_state_stop.png?v=2);
    color: #ff0000;
  }
  .row-title {
    background-color: #f7f9fa;
    font-size: 12px;
    color: #636566;
    font-weight: 700;
    padding-left: 16px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    line-height: 40px;
  }
  .row-border { border-bottom: 1px solid #eee; }
  .grid-content {
    line-height: 50px;
  }
  .grid-content-small {
    line-height: 35px;
  }
  .change-name .edit-name { display: inline-block;}
  .edit-name {
    display: none;
    width: 14px;
    height: 14px;
    background: url(../../assets/imgs/server_edit.png) no-repeat center;
    vertical-align: -1.5px;
    cursor: pointer;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .server-monitor-box {
    float: left;
    position: relative;
    z-index: 10;
    width: 100%;
    height: 374px;
    margin-bottom: 25px;
    border: 1px solid #e8eced;
  }
  .server-monitor-content.list .server-monitor-box {
    width: 48%;
  }
  .server-monitor-content.list .server-monitor-box:first-child,
  .server-monitor-content.list .server-monitor-box:first-child + .server-monitor-box + .server-monitor-box {
    margin-right: 2%;
  }
  .server-monitor-box > div.charts-container {
    width: 100%;
    height: 374px;
  }
  .server-monitor-box .server-monitor-btn {
    position: absolute;
    left: 20px;
    top: 12px;
    z-index: 1;
  }
  .server-monitor-content.cpu .server-monitor-box {
    width: 98%;
  }
  .error-img {
    width: 100px;
    height: 30px;
    vertical-align: -10px;
    margin-left: 10px;
    cursor: pointer;
  }

  .host-uselevel-bar.progress {
    display: inline-block;
    margin-bottom: -11px;
    height: 32px;
    border-radius: 0;
  }
  .host-uselevel-bar {
    position: relative;
    width: 300px;
  }
  .host-uselevel-bar .progress-bar-blue {
    background: #00aaff;
  }
  .usage-text {
    position: absolute;
    left: 43%;
    top: 10px;
    line-height: 1;
    margin-left: -20px;
  }
  .progress {
    height: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
  }
  .progress-bar {
    float: left;
    width: 0;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    background-color: #337ab7;
    -webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    -webkit-transition: width .6s ease;
    -o-transition: width .6s ease;
    transition: width .6s ease;
  }
  .eye-open {
    position: absolute;
    top: 6px;
    right: 1px;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../../assets/imgs/eye_open.png) no-repeat center;
    background-size: 100%;
    vertical-align: -1.5px;
    cursor: pointer;
  }
  .eye-close {
    position: absolute;
    top: 6px;
    right: 1px;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../../assets/imgs/eye_close.png) no-repeat center;
    background-size: 100%;
    vertical-align: -1.5px;
    cursor: pointer;
  }
  .blue-btn {
    display: inline-block;
    background-color: #00aaff;
    color: #fff;
    padding: 20px;
    font-size: 20px;
    margin-left: 74px;
  }
  .gaofang .grid-content {
    line-height: 50px;
    font-size: 14px;
  }
</style>





// WEBPACK FOOTER //
// src/pages/product/server.vue